// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTooltipPopupElement, type TooltipPopupElement } from '@prosekit/web/tooltip';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes } from 'react';

/** Props for the {@link TooltipPopup} React component. */
export interface TooltipPopupProps {}

function TooltipPopupComponent(props: TooltipPopupProps, forwardedRef: ForwardedRef<TooltipPopupElement>) {
  registerTooltipPopupElement();

  const elementRef = useRef<TooltipPopupElement>(null);

  const { ...restProps } = props;

  const mergedRef = useCallback(
    (element: TooltipPopupElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-tooltip-popup', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-tooltip-popup` custom element. */
export const TooltipPopup: ForwardRefExoticComponent<TooltipPopupProps & HTMLAttributes<TooltipPopupElement> & RefAttributes<TooltipPopupElement>> = /* @__PURE__ */ forwardRef(TooltipPopupComponent);
